module.exports = __webpack_public_path__ + "static/media/6C.dc1e4d33.svg";